import { PLANS } from "./billing";

/**
 * How many people may join one session on an organisation with no subscription — the
 * free plan. Read from the plan catalogue (billing.ts), so the number lives in one place.
 */
export const FREE_PARTICIPANT_LIMIT = PLANS.free.participantLimit;
